/**
 * External documentation links.
 *
 * Confluence pages here live in the internal BHI space, so only link to them
 * from BHI Admin surfaces - a company user would get a permission error.
 */
export const MESSAGE_ERROR_REFERENCE_URL =
  'https://bhisoftware.atlassian.net/wiki/spaces/BS/pages/299794433/Message+Error+Reference';
